(function ($) {
    'use strict';

    var $doc = $(document);

    var send = function (el, event) {
        if (!window.gtag && !window.ga) return;

        if (event && event.type) event = event.type;
        else if (!event) event = 'click';

        var $el    = $(el),
            type   = window.gtag ? 1 : 2,
            data   = {},
            action = $el.data('eventAction') || event;

        if (type == 2) data.eventAction = action;
        data[type == 1 ? 'event_category' : 'eventCategory'] = $el.data('eventCategory');

        var label, value;

        if ((label = $el.data('eventLabel'))) data[type == 1 ? 'event_label' : 'eventLabel'] = label;
        if ((value = $el.data('eventValue'))) data[type == 1 ? 'value' : 'eventValue'] = value;

        type == 1 ? gtag('event', action, data) : ga('send', 'event', data);
    };

    $doc.on('click', '[data-gatrack="click"]', function () {
        send(this, 'click');
    });

    $doc.on('submit', '[data-gatrack="submit"]', function () {
        send(this, 'submit');
    });
})(window.jQuery);
